import { useContext } from 'react';
import { SessionContext } from 'auth/helpers/session.context';
import { RealEstateInputDto } from 'services/settings/settings.dto';
import { SettingsService, useAPISettingsService } from 'services/settings/settings.service';

export type EditableRealEstateLabelField = keyof Pick<
    RealEstateInputDto,
    'contractGeneralDataLabel' | 'contractDetailsLabel' | 'contractObservationsLabel'
>;

export interface EditableRealEstateLabel {
    value: string;
    onSave: (newValue: string) => void;
}

export const useEditableRealEstateLabel = (
    field: EditableRealEstateLabelField,
    defaultValue: string,
    settingsService: SettingsService = useAPISettingsService(),
): EditableRealEstateLabel => {
    const { sessionData, setSessionData } = useContext(SessionContext);

    const value = sessionData.realEstate?.[field] ?? defaultValue;

    const onSave = (newValue: string) => {
        settingsService.editSettings({ [field]: newValue }).then(() => {
            setSessionData((prevState) => {
                return {
                    ...prevState,
                    realEstate: { ...prevState.realEstate, [field]: newValue },
                };
            });
        });
    };

    return { value, onSave };
};
